<script lang="ts">
	import type { FooterLinks } from '$lib/components/seo/types';
	import type { PoiCategory } from '../types';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { isMainPoiCategory } from '../utils';
	import PoiFilters from './PoiFilters.svelte';

	const mapLayoutContext = getMapLayoutContext();
	const { mapPoiCategories } = mapLayoutContext;

	// TODO: remove this when we have a better way to handle footer links
	export let partnersLinks: FooterLinks[];
	export let withPartner = false;
	export let detailedView = false;

	function handleCategoriesChange(poiCategories: PoiCategory[]) {
		mapPoiCategories.emitUpdate(poiCategories.filter(isMainPoiCategory));
	}
</script>

<div
	class="fixed md:relative top-0 h-full pt-1 md:pt-2 md:h-auto w-full md:w-auto bg-neutral-weakest"
>
	<PoiFilters
		selectedPoiCategories={$mapPoiCategories}
		{partnersLinks}
		{withPartner}
		{detailedView}
		onPoiCategoriesChange={handleCategoriesChange}
		on:selectDates
		on:clearDates
		on:michelinSelectionChange
		on:poiFilterChange
		on:goBack
	/>
</div>
